<aside class="sidebar" [class.collapsed]="isCollapsed" [class.mobile-open]="isMobileOpen">
  <div class="sidebar-top">
    <div class="sidebar-logo">
      @if (isCollapsed) {
        <img [src]="logoSmall" alt="Logo" />
      } @else {
        <img [src]="logoFull" alt="Logo" />
      }
    </div>
    @if (userEmail && !isCollapsed) {
      <span class="sidebar-user-label" [title]="userEmail">{{ userEmail }}</span>
    }
  </div>
  @if (sidebarItems && sidebarItems.length > 0) {
    <nav class="sidebar-menu">
      @for (item of sidebarItems; track item.route) {
        <a
          class="sidebar-link"
          [routerLink]="item.route"
          routerLinkActive="active"
          [title]="(item.labelKey | translate)"
          >
          <span class="sidebar-icon">
            <fa-icon [icon]="item.icon"></fa-icon>
          </span>
          @if (!isCollapsed) {
            <span class="sidebar-label">{{ item.labelKey | translate }}</span>
          }
        </a>
      }
    </nav>
  }

  <div class="sidebar-bottom">
    <a class="sidebar-link settings-link"
      [routerLink]="routePrefix + '/settings'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      [title]="'SIDEBAR.SETTINGS' | translate">
      <span class="sidebar-icon">
        <fa-icon [icon]="faCog"></fa-icon>
      </span>
      @if (!isCollapsed) {
        <span class="sidebar-label">{{ 'SIDEBAR.SETTINGS' | translate }}</span>
      }
    </a>

    <button
      class="sidebar-link tutorial-link"
      (click)="openTutorial()"
      [title]="'SIDEBAR.TUTORIAL' | translate">
      <span class="sidebar-icon">
        <fa-icon [icon]="faGraduationCap"></fa-icon>
      </span>
      @if (!isCollapsed) {
        <span class="sidebar-label">{{ 'SIDEBAR.TUTORIAL' | translate }}</span>
      }
    </button>

    <button
      class="sidebar-collapse-btn"
      (click)="toggleCollapse()"
      [attr.aria-label]="isCollapsed ? ('SIDEBAR.EXPAND' | translate) : ('SIDEBAR.COLLAPSE' | translate)"
      >
      <span class="sidebar-icon">
        <fa-icon [icon]="isCollapsed ? faAngleRight : faAngleLeft"></fa-icon>
      </span>
      @if (!isCollapsed) {
        <span class="sidebar-label">
          {{ 'SIDEBAR.COLLAPSE' | translate }}
        </span>
      }
    </button>
    <button class="sidebar-logout" (click)="logout()">
      <span class="sidebar-icon">
        <fa-icon [icon]="faSignOutAlt"></fa-icon>
      </span>
      @if (!isCollapsed) {
        <span class="sidebar-label">{{ 'SIDEBAR.LOGOUT' | translate }}</span>
      }
    </button>

    <div class="sidebar-brand-footer">
      <img [src]="brandFooterLogo" alt="di2win">
    </div>
  </div>
</aside>